import { InputError } from '@riac/design-system';
import styled from 'styled-components';

export const CatalogPageContainer = styled.div`
  min-height: 1000px;
  flex-wrap: nowrap;
  max-width: 100%;
  display: flex;
  padding: 0 15px;
  background: ${(props) => props.theme.black[0]};
`;

export const CatalogContainer = styled.div`
  
  flex-grow: 1;
  width: 100%;
  max-width: 100%;
  ${(props) => props.theme.desktop} {
    padding: 35px;
    width: 1600px;
    max-width: 1600px;
  }
`;

export const CatalogSolrError = styled(InputError)`
  &&& {
    margin: 1em 0;
    padding: 1em;
  }
`;
